var _circle, _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLossProfit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 70,
    viewBox: "0 0 71 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 35,
    r: 35,
    transform: "matrix(-1 0 0 1 70.3335 0)",
    fill: "#FEF0C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.3335 37C51.3335 35.8954 50.4381 35 49.3335 35H45.3335C44.2289 35 43.3335 35.8954 43.3335 37V47C43.3335 48.1046 44.2289 49 45.3335 49H49.3335C50.4381 49 51.3335 48.1046 51.3335 47V37Z",
    fill: "#B54708"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3335 29C39.3335 27.8954 38.4381 27 37.3335 27H33.3335C32.2289 27 31.3335 27.8954 31.3335 29V47C31.3335 48.1046 32.2289 49 33.3335 49H37.3335C38.4381 49 39.3335 48.1046 39.3335 47V29Z",
    fill: "#B54708"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3335 23C27.3335 21.8954 26.4381 21 25.3335 21H21.3335C20.2289 21 19.3335 21.8954 19.3335 23V47C19.3335 48.1046 20.2289 49 21.3335 49H25.3335C26.4381 49 27.3335 48.1046 27.3335 47V23Z",
    fill: "#B54708"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2342_50081)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.3335 29L44.8335 19.5L39.8335 24.5L32.3335 17M54.3335 29H48.3335M54.3335 29V23",
    stroke: "#F79009",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2342_50081"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(31.3335 11)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLossProfit);
export default __webpack_public_path__ + "static/media/LossProfit.35ac2c6437c1b3731ef222acc488d271.svg";
export { ForwardRef as ReactComponent };